"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaPassengerSelectionPopup = _interopRequireDefault(require("./AaPassengerSelection-Popup.component"));

var _AaPassengerSelection = require("./AaPassengerSelection.model");

var _AaIcon = _interopRequireDefault(require("../airasia-icon-component/AaIcon.component"));

var _AaIconTypes = _interopRequireDefault(require("../airasia-icon-component/AaIconTypes"));

var _uiUtils = require("@airasia/ui-utils");

var _this = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Reynier [Apr. 3, 2020]
 * Retaining to Cross Platform because other teams might using it as of the moment 
 */
var AaPassengerSelection = function AaPassengerSelection(props) {
  /**
   * State that holds the final output of AaPassengerSelection
   */
  var _useState = (0, _react.useState)(props.data),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      passengerCount = _useState2[0],
      setPassengerCount = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isModalOpen = _useState4[0],
      setIsModalOpen = _useState4[1];
  /**
   * 
   * @param {boolean} val
   * 
   * Determines if passenger will be open or not
   */


  var toggleModal = function toggleModal(val) {
    setIsModalOpen(val);
  };

  _react["default"].useEffect(function () {
    if (props.data) {
      setPassengerCount(props.data);
    }
  }, [props.data.adult, props.data.child, props.data.infant]);

  var updatePassengerCount = function updatePassengerCount(paxCount) {
    props.controls.onUpdate(paxCount);
    setPassengerCount(_objectSpread({}, paxCount));
  };

  var popupConfig = {
    controls: {
      onBackdropClose: toggleModal,
      onChangeData: updatePassengerCount,
      max: props.controls.max,
      min: props.controls.min,
      openModal: isModalOpen,
      isMobilePlatform: props.controls.isMobilePlatform,
      isMobileLayout: props.controls.isMobileLayout
    },
    data: props.data
  };
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.passengerSelectionContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, (0, _extends2["default"])({
    accessibilityRole: "button",
    style: styles.touchable,
    onPress: toggleModal.bind(_this, true)
  }, props.controls.otherTouchableOpacityProps), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: {
      alignItems: 'center',
      flexDirection: 'row'
    }
  }, passengerCount.adult > 0 ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.labelPassenger
  }, " ", passengerCount.adult, " ", props.translation.adultLabel) : null, passengerCount.child > 0 ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.labelPassenger
  }, ", ", passengerCount.child, " ", props.translation.childLabel) : null, passengerCount.infant > 0 ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.labelPassenger
  }, ", ", passengerCount.infant, " ", props.translation.infantLabel) : null), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.textInputIcon
  }, /*#__PURE__*/_react["default"].createElement(_AaIcon["default"], {
    controls: {
      iconName: _AaIconTypes["default"].ARROW_DROPDOWN,
      iconStyle: {
        height: 24,
        width: 24
      }
    }
  })))), isModalOpen ? /*#__PURE__*/_react["default"].createElement(_AaPassengerSelectionPopup["default"], {
    controls: popupConfig.controls,
    data: popupConfig.data,
    translation: props.translation
  }) : null);
};

var styles = _StyleSheet["default"].create({
  passengerSelectionContainer: {
    position: "relative",
    //height: "100%",
    zIndex: 10,
    top: 2
  },
  touchable: {
    flexDirection: "row"
  },
  textInputIcon: {
    position: 'relative',
    left: -10
  },
  labelPassenger: {
    fontSize: 14,
    color: "#1d1d1d",
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontWeight: '400',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  }
});

var _default = AaPassengerSelection;
exports["default"] = _default;